import {
  BellIcon,
  CapaIcon,
  ChangeControlIcon,
  CheckIcon,
  ControlledDocumentIcon,
  CourseIcon,
  CurriculumIcon,
  DelegationIcon,
  DeleteIconStrong,
  DeviationIcon,
  MaterialIcon,
  OkIcon,
  QualityIncidentIcon,
  QuizIcon,
  UserIcon,
  WarningIcon,
} from '@celito.clients/assets';

const pngIconNameMap: Record<string, string> = {
  bell_icon: BellIcon,
  capa_icon: CapaIcon,
  change_control_icon: ChangeControlIcon,
  check_icon: CheckIcon,
  controlled_document_icon: ControlledDocumentIcon,
  course_tab_icon: CourseIcon,
  curriculum_tab_icon: CurriculumIcon,
  delegation_icon: DelegationIcon,
  DeleteStrong: DeleteIconStrong,
  deviation_icon: DeviationIcon,
  okay_icon: OkIcon,
  quality_incident_icon: QualityIncidentIcon,
  quiz_icon_name: QuizIcon,
  training_material_icon: MaterialIcon,
  training_plan_icon: UserIcon,
  warning_icon: WarningIcon,
};

export default pngIconNameMap;
